import { observer } from 'mobx-react-lite';
import { _noop } from 'utils/function.utils';
import styles from './accordion-item.module.scss';

export const AccordionItem = observer(
  ({
    title,
    subTitle,
    link,
    children = null,
    canExpand = false,
    isLast,
    isActive,
    isSelected,
    addActiveClass = true,
    onClick = _noop,
    iconLeft,
    iconLeftActive,
    iconRight,
    iconRightActive,
    className,
    noBackgroundColour = false,
  }: {
    title: string;
    subTitle?: string;
    link?: string | null;
    children?: JSX.Element | string | null;
    canExpand?: boolean;
    isLast?: boolean;
    isActive?: boolean;
    isSelected?: boolean;
    addActiveClass?: boolean;
    noBackgroundColour?: boolean;
    onClick?: () => void;
    iconLeft?: string;
    iconLeftActive?: string | null;
    iconRight?: string;
    iconRightActive?: string;
    className?: string;
  }) => {
    const handleOnClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    };

    const body = (
      <>
        <div className={`d-flex align-items-center flex-nowrap cust-px-3 cust-px-lg-2 ${styles.titleContainer} ${noBackgroundColour && styles.noBG}`}>
          <div className={`d-flex align-items-center flex-grow-1 flex-nowrap ${styles.title}`}>
            {iconLeft && !(isActive && iconLeftActive === null) && (
              <div className={`cust-mr-2 ${styles.itemIcon}`}>
                <i className={isActive && iconLeftActive ? iconLeftActive : iconLeft}></i>
              </div>
            )}
            <h4 className={`text-body-small text-bold ${styles.text_lg_normal} mb-0`}>
              {title}
              {subTitle && <><br /><span className={`text-regular text-body-small mb-0`}>{subTitle}</span></>}
            </h4>
          </div>
          {canExpand && (
            <div className={`${styles.dropdownIcon} ${isActive ? !iconRightActive && styles.rotateIcon : !iconRight && styles.rotateIcon}`}>
              <i className={`${isActive ? iconRightActive || 'icon-Arrow_left_thin' : iconRight || 'icon-Arrow_right_thin'}`}></i>
            </div>
          )}
        </div>
        {canExpand && children && <div className={`cust-px-4 ${styles.body}`}>{children}</div>}
      </>
    );

    return canExpand ? (
      <div
        className={` cursor-pointer canExpand ${styles.accordionItemContainer} ${isLast ? 'isLast' : ''} ${isActive && addActiveClass ? styles.isActive : ''
          } ${isSelected && addActiveClass ? styles.isSelected : ''} ${className}`}
        onClick={handleOnClick}
      >
        {body}
      </div>
    ) : (
      <a
        className={`cursor-pointer ${styles.accordionItemContainer} ${isLast ? 'isLast' : ''} ${isActive && addActiveClass ? styles.isActive : ''
          } ${isSelected && addActiveClass ? styles.isSelected : ''} ${className}`}
        onClick={handleOnClick}
        href={link ? link : '#'}
      >
        {body}
      </a>
    );
  }
);